import { useDeleteCustomItem } from "../../hooks"
import { deleteCustomRepairTimes } from "../deleteCustomRepairTimes"
import { CustomRepairTimeItemResponse } from "../models"
import { QUERY_KEY_REPAIRTIMES } from "./keys"

export function useDeleteCustomRepairTimes() {
    return useDeleteCustomItem(QUERY_KEY_REPAIRTIMES, deleteCustomRepairTimes, (_, { ids }, prevData: CustomRepairTimeItemResponse[]) =>
        prevData.filter((x) => !ids.includes(x.id))
    )
}
